import React from "react";

const OUrValuesModel = ({
  icon,
  text = "Understanding and satisfying our customer's need",
}) => {
  return (
    <div
      className="
        group
        relative 
        min-h-[200px] 
        max-w-[340px] 
        w-full
        bg-[#e7fdf4]
        hover:bg-gradient-to-br 
        hover:from-[#062b6c] 
        hover:to-[#2b9768]
        p-8
        rounded-2xl
        flex 
        flex-col 
        justify-between 
        gap-4
        shadow-[0_10px_25px_rgba(0,0,0,0.1)]
        hover:shadow-[0_18px_40px_rgba(0,0,0,0.25)]
        transition-all 
        duration-500
        hover:-translate-y-2
        hover:text-white
      "
    >
      <div className="text-[#062b6c] group-hover:text-white transition-all duration-500 text-4xl">
        {icon}
      </div>

      <p className="text-lg font-medium leading-tight group-hover:font-semibold transition-all duration-500">
        {text}
      </p>

      {/* Accent glow */}
      <div
        className="
          absolute inset-x-0 -bottom-2 mx-auto
          h-[4px] w-2/5 
          bg-[#2b9768]
          rounded-full
          opacity-0
          group-hover:opacity-100 
          transition-all duration-500
        "
      />
    </div>
  );
};

export default OUrValuesModel;
